import env from "environment";
import { parseTenantFromURL } from "utils";

export const getLinkToCG = (path) => {
  if (typeof window !== "undefined") {
    let subdomain = "";
    const tenant = parseTenantFromURL(window.location.host);

    if (tenant !== window.location.host) {
      subdomain = `${tenant}.`;
    }

    return `https://${subdomain}${env.REACT_APP_CG_STANDALONE_DOMAIN}${path}`;
  }

  return "#";
};

export const redirectToCG = (path, queryParams = {}) => {
  const params = new URLSearchParams(queryParams);

  const url = getLinkToCG(path);

  return window.location.assign(`${url}?${params.toString()}`);
};
